<template>
  <el-dialog
    custom-class="dialog-ad-version-shield"
    :title="dialogTitle"
    :close-on-click-modal="false"
    :modal-append-to-body="false"
    v-model="dialogVisible"
  >
    <!-- 第2行：固定提示 -->
    <div class="avs-hint">策略说明</div>
    <!-- 第3行：固定提示 -->
    <div class="avs-hint avs-hint--desc">
      查询数据库该用户【最近2个跑步分表】的跑步记录数量，若“跑步记录≤2次”，则对该用户屏蔽广告
    </div>

    <!-- 第4行：是否按版本号屏蔽 + 开关 -->
    <div class="avs-switch-row">
      <span class="avs-switch-label">策略是否生效</span>
      <el-switch
        v-model="enableVersionShield"
        @change="onSwitchChange"
      ></el-switch>

      <span v-if="enableVersionShield">
        <el-radio-group v-model="versionShieldMode">
          <el-radio :label="false">全部版本生效</el-radio>
          <el-radio :label="true">指定版本生效</el-radio>
        </el-radio-group>
        <el-button
          v-if="versionShieldMode"
          type="primary"
          @click="clickAddVersion"
          style="margin-left: 20px"
          >添加规则</el-button
        >
      </span>
    </div>

    <!-- 第6行起：开关开启时展示版本号列表（超出 300px 滚动） -->
    <div
      class="avs-version-section"
      v-if="versionShieldMode && enableVersionShield"
    >
      <div class="avs-version-list">
        <div
          class="avs-version-item"
          v-for="(item, index) in versionBlock"
          :key="'ver-' + index"
        >
          <el-form :inline="true">
            <el-form-item label="手机系统">
              <el-select v-model="item.osType" placeholder="请选择">
                <el-option label="Android" value="0"></el-option>
                <el-option label="iOS" value="1"></el-option>
                <el-option label="HarmonyOS" value="2"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="版本号">
              <el-input
                v-model="item.version"
                placeholder="不限制（可为空）"
              ></el-input>
            </el-form-item>
            <el-button
              type="danger"
              icon="delete"
              @click="clickDeleteVersion(index)"
            ></el-button>
          </el-form>
        </div>
      </div>
    </div>

    <!-- 第5行：取消 / 确定 -->
    <template #footer>
      <div class="flex-row-center">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="clickEditDone">确定</el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script>
export default {
  props: {
    dialogTitle: "",
    dataSource: {},
    campusDataSource: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      dialogVisible: false,
      versionShieldMode: false,
      loading: false,
      // 是否按版本号屏蔽
      enableVersionShield: false,
      // 版本号屏蔽列表：每行 手机系统 + 版本号
      versionBlock: [{ osType: "", version: "" }],
    };
  },

  methods: {
    // 发送更新
    sendUpdate() {
      const resValue = {
        enableVersionShield: this.enableVersionShield,
      };
      // 只要选了手机系统即为有效规则，版本号允许留空（空=不限制版本）
      const versionValue = this.versionBlock
        .filter((item) => item.osType && item.osType !== "")
        .map((item) => ({ osType: item.osType, version: item.version || "" }));
      resValue.versionBlock = versionValue;

      if (!this.versionShieldMode) delete resValue.versionBlock;

      const param = {
        tag: this.dataSource.tag,
        key: this.dataSource.resKey,
        value: JSON.stringify(resValue),
      };

      this.$http({
        url: this.$util.domain + "/adminapi/v1/tools/addOrUpdateConfig",
        method: "POST",
        dataType: "json",
        body: JSON.stringify(param),
      })
        .then((res) => {
          if (res.data.error === 10000) {
            this.dialogVisible = false;
            this.$emit("refresh");
          } else {
            this.$util.errorMsg(res.message);
          }
        })
        .catch((error) => {
          this.$util.errorMsg("保存失败");
        })
        .finally(() => {
          this.loading = false;
        });
    },

    // 点击编辑：回填已有数据
    clickEdit() {
      // 先重置，避免缓存
      this.enableVersionShield = false;
      console.log("广告按版本屏蔽-回填数据:", this.dataSource);

      this.versionBlock = [{ osType: "", version: "" }];

      if (this.dataSource.resValue && this.dataSource.resValue !== "") {
        try {
          const resValue = JSON.parse(this.dataSource.resValue);
          if (resValue.enableVersionShield) {
            this.enableVersionShield = !!resValue.enableVersionShield;
          }
          if (resValue.versionBlock && Array.isArray(resValue.versionBlock)) {
            this.versionBlock = resValue.versionBlock.map((item) => ({
              osType: String(item.osType),
              version: item.version || "",
            }));
            if (!this.versionBlock.length) {
              this.versionBlock = [{ osType: "", version: "" }];
            }
          }

          this.versionShieldMode = !!(
            resValue.versionBlock && resValue.versionBlock.length
          );
        } catch (error) {
          console.log("广告按版本屏蔽-解析数据失败:", error);
        }
      }
      this.dialogVisible = true;
    },

    // 开关切换：开启时若列表为空，保证至少一行
    onSwitchChange(val) {
      if (val && this.versionBlock.length === 0) {
        this.versionBlock = [{ osType: "", version: "" }];
      }
    },

    // 版本号：添加
    clickAddVersion() {
      this.versionBlock.push({ osType: "", version: "" });
    },
    // 版本号：删除
    clickDeleteVersion(index) {
      this.versionBlock.splice(index, 1);
    },

    // 确认：校验后保存
    clickEditDone() {
      if (this.enableVersionShield && this.versionShieldMode) {
        // 选了手机系统即为有效规则，版本号允许留空
        const valid = this.versionBlock.some(
          (item) => item.osType && item.osType !== ""
        );
        if (!valid) {
          this.$util.errorMsg("请至少选择一条规则的手机系统");
          return;
        }
      }
      this.sendUpdate();
    },
  },
};
</script>

<style scoped>
.avs-hint {
  font-size: 14px;
  line-height: 22px;
  color: #333;
  margin: 8px 0;
}
.avs-hint--desc {
  color: #606266;
}
.avs-switch-row {
  display: flex;
  align-items: center;
  gap: 12px;
  margin: 16px 0 8px;
}
.avs-switch-label {
  font-size: 14px;
  color: #333;
}
.avs-version-section {
  margin-top: 8px;
}
.avs-version-list {
  max-height: 400px;
  overflow-y: auto;
  border-top: 1px dashed #ebeef5;
  padding-top: 28px;
}
.avs-version-item {
  margin-bottom: 10px;
}
</style>

<style>
.dialog-ad-version-shield {
  width: 840px;
}
</style>



// WEBPACK FOOTER //
// AdVersionShield.vue?fe7ab61e